module.exports = __webpack_public_path__ + "static/media/service_logo_new.a1dea85b.png";